import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: {},
    activeTableId: '',
    page: 0,
    statsOpen: false,
    loading: false,
    customTableSetting: null,
};
const { actions, reducer } = createSlice({
    name: 'tablesPrefs',
    initialState,
    reducers: {
        setTableConfig: (state, { payload }) => {
            const { tableId, property, value, data } = payload;
            state.data = Object.assign(Object.assign({}, state.data), { [tableId]: Object.assign(Object.assign({}, state.data[tableId]), data) });
        },
        setTableOrdering: (state, { payload }) => {
            state.data[state.activeTableId].sortBy.orderingString = payload;
        },
        setActiveTableId: (state, { payload }) => {
            state.activeTableId = payload;
        },
        setTablePage: (state, { payload }) => {
            state.page = payload;
        },
        setCustomTableSetting: (state, { payload }) => {
            state.customTableSetting = payload;
        },
    },
});
export const { setTableConfig, setTableOrdering, setActiveTableId, setTablePage, setCustomTableSetting } = actions;
export default reducer;
